import './formatPhoneNumber';
import './imageUrlParse';
import './limitDescription';
import './normalizeForTranslate';
import './phoneCountryCode';
import './ucfirst';
import './date-in-miliseconds';
import './filterState';
import './filterCurrencies';



// WEBPACK FOOTER //
// ./scripts/filters/index.js